import { getCookie, setCookie } from "./cookiebanner";
import { personalizationHeroBanner } from "./personalization-banner";

export function showControl(compsList = []) {
  document.querySelectorAll('[data-abtesttype="control"]').forEach((elem) => {
    if (!compsList.includes(elem.dataset.component)) {
      elem.style.visibility = null;
    }
  });
}

export function abTestVTwo(ocw_experiment) {
  let experimentComps = document.querySelectorAll("[data-component]");
  let activeComponents = [];
  const currLang = document.documentElement.lang;
  let pageComponents = []; // Array to store all components on the page
  if (!experimentComps) {
    showControl();
    return;
  }

  experimentComps.forEach((elem) => {
    if (elem.dataset.component) {
      pageComponents.push(elem.dataset.component);
    }
  });
  
  if (Object.keys(ocw_experiment).length) {
    for (const singleExperiment in ocw_experiment) {
      const payload = ocw_experiment[singleExperiment]?.payload;
      const abtestKey = ocw_experiment[singleExperiment]?.key;
      
      if (payload?.component !== undefined) {
          // if it's an array of components 
        if (Array.isArray(payload.component)) {
          payload.component.forEach((component)=>{
            if (pageComponents.includes(component)) {
              activeComponents.push(component);
            }
          });
          if(activeComponents.length > 0 && abtestKey !== 'control'){
            // Hide all control elements
            document.querySelectorAll('[data-abtesttype="control"]').forEach((elem) => {
              elem.style.visibility = "hidden";
            });

            const params = {
              components: JSON.stringify(pageComponents),
              abtestype: abtestKey,
              lang: currLang,
            };
            // Fetch and render the module content
            handleVariant(params);
          }
        }
      }
      // If it's a single component
      else if (typeof payload.component === "string") {
         experimentComps.forEach((elem) => {
          if (payload.component === elem.dataset.component) {
            pageComponents.push(elem.dataset.component);
            if(pageComponents.length > 0 && abtestKey !== 'control'){
            // Hide all control elements
            document.querySelectorAll('[data-abtesttype="control"]').forEach((elem) => {
              elem.style.visibility = "hidden";
            });

            const params = {
              components: JSON.stringify(pageComponents),
              abtestype: abtestKey,
              lang: currLang,
            };
            // Fetch and render the module content
            handleVariant(params);
          }
          }
        });
      }
    }
    showControl(activeComponents);
  } else {
    showControl();
  }
}

function handleVariant(params) {
  const currUrl = window.location.origin + "/wp-json/ocw-personalization/abtest/";
  fetch(currUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) throw new Error(response);
      return response.json();
    })
    .then((data) => {
      if (data && Array.isArray(data)) {
        // Iterate over the response and replace content in the DOM
        data.forEach((module) => {
          const targetElem = document.querySelector(`[data-component="${module.component}"]`);
          if (targetElem) {
            // Replace the content of the target element
            const rawHtml = module.html.replace(/\\([\\"])/g, '$1');
            targetElem.insertAdjacentHTML('afterend', rawHtml);
            // Remove control elements if necessary
            if (targetElem.dataset.abtesttype === "control") {
               targetElem.remove();
            }
          } else {
            console.warn(`No matching element found for component: ${module.component}`);
          }
        });
      } else {
        console.log("No valid modules returned from API.");
      }
    })
    .catch((error) => {
      console.error("Error fetching components:", error);
    });
}

export function splitUrlTest() {
  const langtoggle = document.querySelectorAll('.wpml-ls-link');
  langtoggle.forEach(link => {
    try {
      const url = new URL(link.href);
      if (
        link.href === "https://oportun.com/" ||
        link.href === "https://oportunstg3.wpengine.com/" ||
        link.href === "https://oportundev3.wpengine.com/"
      ) {
        console.log(link.href + "us");
        link.href = link.href + "us";
      }
    } catch (e) {
      console.error("Error processing URL:", e);
    }
  });
}